<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'PicVerifyImgCode',
})
</script>
<template>
  <div :class="bem()" @click="refresh">
    <Spin :spinning="state.loading">
      <img :class="bem('pic')" :src="state.pic" />
    </Spin>
  </div>
</template>

<script lang="ts" setup name="PicVerifyImgCode">
import { createNamespace } from '@bd/vue3-utils'
import { message, Spin } from 'ant-design-vue'
import { useVModel } from '@vueuse/core'
import { reactive } from 'vue'
import { API_VERIFY_PIC_CODE } from '@/api/verify'
const [_, bem] = createNamespace('PicVerifyImgCode')
const props = defineProps<{
  uuid?: string
}>()
const emits = defineEmits(['update:uuid'])
const uuidTmp = useVModel(props, 'uuid', emits)
const state = reactive({
  pic: '',
  loading: false
})
/**
 *获取图片验证码
 */
const refresh = async () => {
  if (state.loading) return
  state.loading = true
  try {
    const data = await API_VERIFY_PIC_CODE()
    state.pic = data.blob
    uuidTmp.value = data.uuid
  } catch (err) {
    message.error('获取失败')
  }
  state.loading = false
}
refresh()
defineExpose({
  refresh
})
</script>

<style lang="less">
.pic-verify-img-code {
  flex: 0 0 120px;
  width: 120px;
  background: @white;

  img {
    cursor: pointer;
    width: 100%;
    height: 40px;
  }
}
</style>
